import MainViews from './MainViews.connect';

export default MainViews;
